(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskVerificationListController', TaskVerificationListController);

    TaskVerificationListController.$inject = ['$scope', '$state','TaskVerificationRedone', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal'];

    function TaskVerificationListController ($scope, $state, TaskVerificationRedone, ParseLinks, AlertService, paginationConstants, pagingParams, Principal) {
        var vm = this;
        window.vvm = vm;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAllTaskVerifications();

        function loadAllTaskVerifications() {
            TaskVerificationRedone.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'tic.title') {
                    result.push('tic.title');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskVerifications = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
